<template>

    <div id="break-ad" class="break-ad" :style="{display: (showBreakAd ? 'block' : 'none')}">
        <div :id="adType+adSuffix" class="gujAd" :class="adType"></div>
    </div>

</template>

<script>

    export default {

        name: 'BreakAd',

        props: {
        },

        data () {
            return {
                showBreakAd: false,
                calls: 0,
                adType: 'breakad',
                adSuffix: '_1',
                scriptTestUrl: 'https://adctrl.emsmobile.de/preview/rtl2.de/gujAd.js',
                scriptLiveUrl: 'https://www.rtl2.de/live/rtl2.de/gujAd.js',
            }
        },

        watch: {
        },

        mounted () {

            this.$l.log('Break-Ad component mounted', this.$settings.breakAd);

            // Set global variable
            window.GujAd = {}
            GujAd.cmd = GujAd.cmd || []

            // Initialize ad
            this.initializeGujAd();

        },

        methods: {

            loadGuJAdScript: function () {

                // console.log('start loadGuJAdScript');

                // Variables
                var vm = this;

                let s = document.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.src = (window.location.search.indexOf('gujAd=1') > -1) ? vm.scriptTestUrl : vm.scriptLiveUrl;
                document.body.appendChild(s);

                // console.log('end loadGuJAdScript');

            },

            finalizeGuJAdScript: function () {

                // console.log('start finalizeGuJAdScript');

                if (GujAd !== undefined && GujAd.cmd !== undefined) {
                    GujAd.cmd.push(function() {
                        GujAd.finalize();
                    });
                }

                // console.log('end finalizeGuJAdScript');

            },

            initializeGujAd: function () {

                // console.log('start initializeGujAd');

                // Variables
                var vm = this;

                if (GujAd !== undefined && GujAd.cmd !== undefined) {
                    GujAd.cmd.push(function() {
                        GujAd.push(vm.adType+vm.adSuffix);
                    });
                }

                // console.log('end initializeGujAd');

            },

            loadAd: function () {
                this.loadGuJAdScript();
                this.finalizeGuJAdScript();
            },

            reloadAd: function () {

                // console.log('start reloadAd');

                // Variables
                var vm = this;

                if (typeof GujAd !== 'undefined' && typeof GujAd.cmd !== 'undefined') {
                    GujAd.cmd.push(function () {
                        GujAd.getClient().reloadAd(vm.adType+vm.adSuffix);
                    });
                }

                // console.log('end reloadAd');

            },

        },

        events: {

            jwPlay () {
                this.showBreakAd = false;
            },

            jwPause () {
                !this.calls ? this.loadAd() : this.reloadAd();
                this.calls++;
                this.showBreakAd = true;
            },
        },
    }
</script>

<style lang="scss">
    .break-ad {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 9999;
        pointer-events: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/ads/BreakAd.vue